// extracted by mini-css-extract-plugin
module.exports = {"header":"Guide_header__3DfY1","blocks":"Guide_blocks__ywv-P","button":"Guide_button__3ih3N"};